export const SIDEBAR_WIDTH = '240px'
export const USE_DRAWER = '(max-width: 1200px)'
